var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _defs, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _g, _g2, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _defs2, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _defs3, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _g3, _g4, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlustracion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1674 388",
    style: {
      enableBackground: "new 0 0 1674 388"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BEBEBE;}\n\t.st1{fill:#414141;}\n\t.st2{fill:#FFD52B;}\n\t.st3{clip-path:url(#SVGID_00000047750877033468261930000002981046910178616962_);}\n\t.st4{opacity:0.7;fill:#414141;enable-background:new    ;}\n\t.st5{clip-path:url(#SVGID_00000133489947999681649200000003426689316092793533_);}\n\t.st6{clip-path:url(#SVGID_00000059296636565999714920000002733461385439978905_);}\n\t.st7{fill:#D3D1D3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.4,323.3h53.4V110.9h-53.4V323.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.1,185H278V95.7h-35.9V185z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.1,135.6H270V86.1h-19.9V135.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.9,111.5h-13.6V77.8h13.6V111.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.2,96.8h-1.5V63.1h1.5V96.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.5,85.1H261V51.4h1.5V85.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.2,112.7H232v-2.3h56.2V112.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.4,96.8h-38.5v-2.2h38.5V96.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.9,86.8h-22.2v-1.7h22.2V86.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.4,108.7h1.7v-9.4h-1.7V108.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.1,108.7L250.1,108.7l0.1-9.4h-0.1V108.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.1,108.7h1.6v-9.4h-1.6V108.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.7,108.7h1.7v-9.4h-1.7V108.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.3,108.7h1.7v-9.4h-1.7V108.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.9,108.7h1.7v-9.4h-1.7V108.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270,108.7h0.2v-9.4H270V108.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.5,108.7h1.5v-9.4h-1.5V108.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.2,108.7h1.7v-9.4h-1.7V108.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.1,130.5h-4v-11.1h4V130.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.1,130.5h4v-11.1h-4V130.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,130.5h-4v-11.1h4V130.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.1,130.5h-4v-11.1h4V130.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,130.5h-4v-11.1h4V130.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,130.5h-4v-11.1h4V130.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.1,147.8h-4v-11.1h4V147.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.1,147.8h-4v-11.1h4V147.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,147.8h-4v-11.1h4V147.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.1,147.8h4v-11.1h-4V147.8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,147.8h-4v-11.1h4V147.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,147.8h-4v-11.1h4V147.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.1,165.1h-4V154h4V165.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.1,165.1h-4V154h4V165.1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,165.1h-4V154h4V165.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.1,165.1h-4V154h4V165.1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.1,165.1h4V154h-4V165.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278,165.1h4V154h-4V165.1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1,182.4h4v-11.1h-4V182.4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.1,182.4h-4v-11.1h4V182.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,182.4h-4v-11.1h4V182.4z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.1,182.4h-4v-11.1h4V182.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,182.4h-4v-11.1h4V182.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,182.4h-4v-11.1h4V182.4z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.1,199.7h-4v-11.1h4V199.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.1,199.7h4v-11.1h-4V199.7z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,199.7h-4v-11.1h4V199.7z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.1,199.7h4v-11.1h-4V199.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,199.7h-4v-11.1h4V199.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,199.7h-4v-11.1h4V199.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.1,217h-4v-11.1h4V217z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.1,217h-4v-11.1h4V217z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,217h-4v-11.1h4V217z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.1,217h-4v-11.1h4V217z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,217h-4v-11.1h4V217z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278,217h4v-11.1h-4V217z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.1,234.3h-4v-11.1h4V234.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.1,234.3h4v-11.1h-4V234.3z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.1,234.3h4v-11.1h-4V234.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.1,234.3h-4v-11.1h4V234.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,234.3h-4v-11.1h4V234.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,234.3h-4v-11.1h4V234.3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.1,251.6h-4v-11.1h4V251.6z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.1,251.6h-4v-11.1h4V251.6z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,251.6h-4v-11.1h4V251.6z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.1,251.6h-4v-11.1h4V251.6z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.1,251.6h4v-11.1h-4V251.6z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,251.6h-4v-11.1h4V251.6z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.1,268.8h-4v-11.1h4V268.8z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.1,268.8h4v-11.1h-4V268.8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,268.8h-4v-11.1h4V268.8z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.1,268.8h-4v-11.1h4V268.8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,268.8h-4v-11.1h4V268.8z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,268.8h-4v-11.1h4V268.8z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.1,286.1h-4V275h4V286.1z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.1,286.1h-4V275h4V286.1z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,286.1h-4V275h4V286.1z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.1,286.1h4V275h-4V286.1z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,286.1h-4V275h4V286.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278,286.1h4V275h-4V286.1z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1,303.4h4v-11.1h-4V303.4z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.1,303.4h-4v-11.1h4V303.4z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.1,303.4h4v-11.1h-4V303.4z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.1,303.4h-4v-11.1h4V303.4z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,303.4h-4v-11.1h4V303.4z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,303.4h-4v-11.1h4V303.4z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1622.4,363.9h51.6V151.5h-51.6V363.9z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1631.1,225.5h35.9v-89.2h-35.9V225.5z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1639.1,176.1h19.9v-49.5h-19.9V176.1z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1655.9,152.1h-13.6v-33.7h13.6V152.1z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1648.2,137.4h-1.5v-33.7h1.5V137.4z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1651.5,125.7h-1.5V92h1.5V125.7z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1674,153.2h-53V151h53V153.2z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1668.4,137.4h-38.5v-2.2h38.5V137.4z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1659.9,127.4h-22.2v-1.7h22.2V127.4z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1634.4,149.3h1.7v-9.4h-1.7V149.3z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1639.1,149.3L1639.1,149.3l0.1-9.4h-0.1V149.3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1639.1,149.3h1.6v-9.4h-1.6V149.3z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1643.7,149.3h1.7v-9.4h-1.7V149.3z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1648.3,149.3h1.7v-9.4h-1.7V149.3z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1652.9,149.3h1.7v-9.4h-1.7V149.3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1659.1,149.3h0.1v-9.4h-0.1V149.3z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1657.5,149.3h1.5v-9.4h-1.5V149.3z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1662.2,149.3h1.7v-9.4h-1.7V149.3z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1631.1,171.1h-4V160h4V171.1z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1635.1,171.1h4V160h-4V171.1z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1647.1,171.1h-4V160h4V171.1z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1655.1,171.1h-4V160h4V171.1z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1663.1,171.1h-4V160h4V171.1z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1671.1,171.1h-4V160h4V171.1z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1631.1,188.4h-4v-11.1h4V188.4z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1639.1,188.4h-4v-11.1h4V188.4z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1647.1,188.4h-4v-11.1h4V188.4z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1651.1,188.4h4v-11.1h-4V188.4z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1663.1,188.4h-4v-11.1h4V188.4z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1671.1,188.4h-4v-11.1h4V188.4z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1631.1,205.7h-4v-11.1h4V205.7z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1639.1,205.7h-4v-11.1h4V205.7z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1647.1,205.7h-4v-11.1h4V205.7z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1655.1,205.7h-4v-11.1h4V205.7z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1659.1,205.7h4v-11.1h-4V205.7z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1667.1,205.7h4v-11.1h-4V205.7z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1627.1,223h4v-11.1h-4V223z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1639.1,223h-4v-11.1h4V223z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1647.1,223h-4v-11.1h4V223z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1655.1,223h-4v-11.1h4V223z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1663.1,223h-4v-11.1h4V223z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1671.1,223h-4v-11.1h4V223z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1631.1,240.3h-4v-11.1h4V240.3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1635.1,240.3h4v-11.1h-4V240.3z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1647.1,240.3h-4v-11.1h4V240.3z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1651.1,240.3h4v-11.1h-4V240.3z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1663.1,240.3h-4v-11.1h4V240.3z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1671.1,240.3h-4v-11.1h4V240.3z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1631.1,257.6h-4v-11.1h4V257.6z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1639.1,257.6h-4v-11.1h4V257.6z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1647.1,257.6h-4v-11.1h4V257.6z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1655.1,257.6h-4v-11.1h4V257.6z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1663.1,257.6h-4v-11.1h4V257.6z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1667.1,257.6h4v-11.1h-4V257.6z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1631.1,274.8h-4v-11.1h4V274.8z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1635.1,274.8h4v-11.1h-4V274.8z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1643.1,274.8h4v-11.1h-4V274.8z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1655.1,274.8h-4v-11.1h4V274.8z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1663.1,274.8h-4v-11.1h4V274.8z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1671.1,274.8h-4v-11.1h4V274.8z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1631.1,292.1h-4V281h4V292.1z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1639.1,292.1h-4V281h4V292.1z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1647.1,292.1h-4V281h4V292.1z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1655.1,292.1h-4V281h4V292.1z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1659.1,292.1h4V281h-4V292.1z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1671.1,292.1h-4V281h4V292.1z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1631.1,309.4h-4v-11.1h4V309.4z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1635.1,309.4h4v-11.1h-4V309.4z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1647.1,309.4h-4v-11.1h4V309.4z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1655.1,309.4h-4v-11.1h4V309.4z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1663.1,309.4h-4v-11.1h4V309.4z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1671.1,309.4h-4v-11.1h4V309.4z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1631.1,326.7h-4v-11.1h4V326.7z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1639.1,326.7h-4v-11.1h4V326.7z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1647.1,326.7h-4v-11.1h4V326.7z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1651.1,326.7h4v-11.1h-4V326.7z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1663.1,326.7h-4v-11.1h4V326.7z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1667.1,326.7h4v-11.1h-4V326.7z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1627.1,344h4v-11.1h-4V344z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1639.1,344h-4v-11.1h4V344z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1643.1,344h4v-11.1h-4V344z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1655.1,344h-4v-11.1h4V344z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1663.1,344h-4v-11.1h4V344z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1671.1,344h-4v-11.1h4V344z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.4,320.5h85.8V141.6h-85.8V320.5z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.6,143.6h-90.6v-5.1h90.6V143.6z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.2,156.1h80v-24h-80V156.1z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.1,148.5h-31.7v-26.3h31.7V148.5z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.7,129.6h-18.3v-13.8h13.1L154.7,129.6z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.8,135.1h1.8v-30.8h-1.8V135.1z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.2,102.7c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6 C145.5,101.1,146.2,101.8,146.2,102.7z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1276.4,370.4h85.8V191.5h-85.8V370.4z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1364.6,193.4H1274v-5.1h90.6V193.4z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1279.3,206h80v-24h-80V206z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1317.1,198.3h-31.7v-26.3h31.7V198.3z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1303.8,179.5h-18.3v-13.8h13.2L1303.8,179.5z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1292.8,185h1.8v-30.8h-1.8V185z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1295.3,152.6c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6S1295.3,151.7,1295.3,152.6z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1190.4,311.5h-93.9l-11.7-263l105.6,21.9V311.5z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.7,200.4v-87.9H81V89h-5.3V54.4h-29V29h-2.6v25.4h-5.7V22.6h-2.6v31.8H17.6v58.1H8.1v87.9H0v160.2h101.4 V200.4H95.7z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,388h1250.2v-40.7H0V388z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1255.8,192.5v-44.1h-15.9v-16.8h-8.5v-14.1h-3V93.4h-0.8v24.2h-3v14.1h-8.5v16.8h-15.8v44.1h-3.3v80h-24.5 v91.2h24.5h24.5h37.5V192.5H1255.8z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M727.9,330.7h-49.7l19.4-99.5h30.3V330.7z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M778.9,197.2h-77.2v1.4h3.5v130.5h70.2V198.6h3.5V197.2z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.9,351.3H234.2v-53h117.7V351.3z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.1,172.3h-25.8v130.2h25.8V172.3z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.3,208.3H303v-70.8h1.3V208.3z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.7,213.7h-1.3v-70.8h1.3V213.7z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.1,181.7h-15.8v-17.4h15.8V181.7z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1359,388h-157v-50h157V388z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1290.9,211.7h-25.8v130.2h25.8V211.7z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1272.1,247.8h-1.3V177h1.3V247.8z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1276.5,253.2h-1.3v-70.8h1.3V253.2z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1282.9,221.1h-15.8v-17.5h15.8V221.1z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M430.7,351.3h-68.4V242.5h68.4V351.3z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M392.3,351.3h-45V262h45V351.3z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.7,351.3h84.4V167.5h-84.4V351.3z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M450,191.8h67.8v-30.6H450V191.8z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.7,173.5h-97.5v-2.1h97.5V173.5z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M466.2,351.3h-39.8v-92.8h39.8V351.3z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.2,351.3h-45.6V255h45.6V351.3z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.3,351.3h90.9V228.8h-90.9V351.3z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.6,228.8H151v-4.7h98.6V228.8z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.3,236.2h-40v-24.8h40V236.2z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.1,226.4h-6.7v-15.1h6.7V226.4z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.2,226.4h-7.4v-15.1h7.4V226.4z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.4,351.3h-47.7V314h47.7V351.3z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.3,351.3H98.7v-53h22.6V351.3z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110,351.3H71.5v-18.6H110V351.3z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1491.8,364.9h-45.6v-96.3h45.6V364.9z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1460.9,364.9h90.9V242.5h-90.9V364.9z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1554.2,242.5h-98.6v-4.7h98.6V242.5z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1504.9,249.8h-40V225h40V249.8z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1524.7,240.1h-6.7V225h6.7V240.1z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1538.7,240.1h-7.4V225h7.4V240.1z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1468.9,364.9h-47.7v-37.3h47.7V364.9z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1425.8,364.9h-22.6v-53h22.6V364.9z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1414.6,364.9H1376v-18.6h38.6V364.9z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M518,381h475v-71H518V381z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M968.9,351.3h73.4V243.8h-73.4V351.3z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1104.9,350.7h-73.4v-65.1h73.4V350.7z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1005.6,351.3h51.9V141.5h-51.9V351.3z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1045.9,154.7h-1.8v-57h1.8V154.7z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1051.9,166.9h-1.8v-57h1.8V166.9z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1040.4,174.8h-1.8v-57h1.8V174.8z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1143,351.3h-68.5V228.8h51.9L1143,351.3z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1101.7,238.2h-24.5v-19.3h24.5V238.2z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1099,222.9h-19.1V212h19.1V222.9z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1116.1,232.3h-4.7v-7.8h4.7V232.3z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1124.5,232.3h-6.7v-14.9h6.7V232.3z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M746.8,388H809V188.8h-62.2V388z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M813.6,192h-71.5v-2h71.5V192z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M811.7,220.2h-67.7v-2h67.7V220.2z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M811.7,247.5h-67.7v-2h67.7V247.5z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M811.7,274.8h-67.7v-2h67.7V274.8z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M811.7,302.1h-67.7v-2h67.7V302.1z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M811.7,329.4h-67.7v-2h67.7V329.4z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M811.7,356.6h-67.7v-2h67.7V356.6z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M816,190h-76.3v-5.5H816V190z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M771.9,187.2h-21.2v-10.4h21.2V187.2z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M773.3,178.3h-24v-1.8h24V178.3z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M657.6,388h-82.9V198.7l82.9-20.1V388z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M578.3,388h-7.3V195.5h7.3V388z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M599.1,388h-7.3V190h7.3V388z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M619.8,388h-7.3V184.3h7.3V388z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M640.5,388h-7.3V179.7h7.3V388z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M661.2,388h-7.3V174.8h7.3V388z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,211.7h4.8v-3.9h-4.8V211.7z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,220.1h4.8v-8.3h-4.8V220.1z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,237.4h4.8v-6.1h-4.8V237.4z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,243.5h4.8v-6.1h-4.8V243.5z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,263h4.8v-8.3h-4.8V263z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,267h4.8V263h-4.8V267z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,288.7h4.8v-10.5h-4.8V288.7z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,290.4h4.8v-1.7h-4.8V290.4z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,312.5h4.8v-9.1h-4.8V312.5z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,303.4h4.8v-3.1h-4.8V303.4z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,336h4.8v-6.9h-4.8V336z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M582.6,329.1h4.8v-5.3h-4.8V329.1z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,211.7h4.8v-3.9h-4.8V211.7z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,220.1h4.8v-8.3h-4.8V220.1z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,237.4h4.8v-6.1h-4.8V237.4z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,243.5h4.8v-6.1h-4.8V243.5z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,263h4.8v-8.3h-4.8V263z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,267h4.8V263h-4.8V267z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,288.7h4.8v-10.5h-4.8V288.7z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,290.4h4.8v-1.7h-4.8V290.4z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,312.5h4.8v-9.1h-4.8V312.5z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,303.4h4.8v-3.1h-4.8V303.4z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,336h4.8v-6.9h-4.8V336z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.4,329.1h4.8v-5.3h-4.8V329.1z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,211.7h4.8v-3.9h-4.8V211.7z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,220.1h4.8v-8.3h-4.8V220.1z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,237.4h4.8v-6.1h-4.8V237.4z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,243.5h4.8v-6.1h-4.8V243.5z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,263h4.8v-8.3h-4.8V263z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,267h4.8V263h-4.8V267z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,288.7h4.8v-10.5h-4.8V288.7z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,290.4h4.8v-1.7h-4.8V290.4z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,312.5h4.8v-9.1h-4.8V312.5z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,303.4h4.8v-3.1h-4.8V303.4z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,336h4.8v-6.9h-4.8V336z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.1,329.1h4.8v-5.3h-4.8V329.1z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,211.7h4.8v-3.9h-4.8V211.7z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,220.1h4.8v-8.3h-4.8V220.1z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,237.4h4.8v-6.1h-4.8V237.4z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,243.5h4.8v-6.1h-4.8V243.5z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,263h4.8v-8.3h-4.8V263z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,267h4.8V263h-4.8V267z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,288.7h4.8v-10.5h-4.8V288.7z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,290.4h4.8v-1.7h-4.8V290.4z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,312.5h4.8v-9.1h-4.8V312.5z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,303.4h4.8v-3.1h-4.8V303.4z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,336h4.8v-6.9h-4.8V336z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.8,329.1h4.8v-5.3h-4.8V329.1z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M589.9,226.5h-9.7v-14.7h2.4v8.3h4.8v-8.3h2.4V226.5z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M610.6,226.5h-9.7v-14.7h2.4v8.3h4.8v-8.3h2.4V226.5z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M621.7,226.5h9.7v-14.7h-9.7V226.5z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M652.1,226.5h-9.7v-14.7h2.4v8.3h4.8v-8.3h2.4V226.5z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M580.2,252.1h9.7v-14.7h-9.7V252.1z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M600.9,252.1h9.7v-14.7h-9.7V252.1z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M631.3,252.1h-9.7v-14.7h2.4v6.1h4.8v-6.1h2.4V252.1z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M652.1,252.1h-9.7v-14.7h2.4v6.1h4.8v-6.1h2.4V252.1z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M589.9,277.8h-9.7V263h2.4v3.9h4.8V263h2.4V277.8z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M610.6,277.8h-9.7V263h2.4v3.9h4.8V263h2.4V277.8z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M631.3,277.8h-9.7V263h2.4v3.9h4.8V263h2.4V277.8z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M642.4,277.8h9.7V263h-9.7V277.8z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M589.9,303.4h-2.4v-3.1h-4.8v3.1h-2.4v-14.7h2.4v1.7h4.8v-1.7h2.4V303.4z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M600.9,303.4h9.7v-14.7h-9.7V303.4z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M631.3,303.4h-2.4v-3.1h-4.8v3.1h-2.4v-14.7h2.4v1.7h4.8v-1.7h2.4V303.4z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M652.1,303.4h-2.4v-3.1h-4.8v3.1h-2.4v-14.7h2.4v1.7h4.8v-1.7h2.4V303.4z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M589.9,329.1h-2.4v-5.3h-4.8v5.3h-2.4v-14.7h9.7V329.1z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M610.6,329.1h-2.4v-5.3h-4.8v5.3h-2.4v-14.7h9.7V329.1z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M621.7,329.1h9.7v-14.7h-9.7V329.1z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M652.1,329.1h-2.4v-5.3h-4.8v5.3h-2.4v-14.7h9.7V329.1z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M589.9,354.7h-9.7V340h9.7V354.7z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M610.6,354.7h-9.7V340h9.7V354.7z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M621.7,354.7h9.7V340h-9.7V354.7z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M642.4,354.7h9.7V340h-9.7V354.7z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M580.2,380.3h9.7v-14.7h-9.7V380.3z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M610.6,380.3h-9.7v-14.7h9.7V380.3z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M621.7,380.3h9.7v-14.7h-9.7V380.3z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M652.1,380.3h-9.7v-14.7h9.7V380.3z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1624.5,368.6h-82.9V178l82.9-20.3V368.6z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1545.3,368.6h-7.3V174.7h7.3V368.6z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1566,368.6h-7.3V169.2h7.3V368.6z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1586.7,368.6h-7.3V163.5h7.3V368.6z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1607.4,368.6h-7.3V158.9h7.3V368.6z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1628.2,368.6h-7.3V154h7.3V368.6z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,191h4.8V187h-4.8V191z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,199.3h4.8V191h-4.8V199.3z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,216.6h4.8v-6.1h-4.8V216.6z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,222.7h4.8v-6.1h-4.8V222.7z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,242.2h4.8v-8.3h-4.8V242.2z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,246.2h4.8v-3.9h-4.8V246.2z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,267.9h4.8v-10.5h-4.8V267.9z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,269.6h4.8v-1.7h-4.8V269.6z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,291.7h4.8v-9.1h-4.8V291.7z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,282.6h4.8v-3.1h-4.8V282.6z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,315.2h4.8v-6.9h-4.8V315.2z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549.6,308.3h4.8v-5.3h-4.8V308.3z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,191h4.8V187h-4.8V191z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,199.3h4.8V191h-4.8V199.3z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,216.6h4.8v-6.1h-4.8V216.6z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,222.7h4.8v-6.1h-4.8V222.7z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,242.2h4.8v-8.3h-4.8V242.2z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,246.2h4.8v-3.9h-4.8V246.2z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,267.9h4.8v-10.5h-4.8V267.9z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,269.6h4.8v-1.7h-4.8V269.6z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,291.7h4.8v-9.1h-4.8V291.7z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,282.6h4.8v-3.1h-4.8V282.6z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,315.2h4.8v-6.9h-4.8V315.2z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1570.3,308.3h4.8v-5.3h-4.8V308.3z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,191h4.8V187h-4.8V191z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,199.3h4.8V191h-4.8V199.3z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,216.6h4.8v-6.1h-4.8V216.6z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,222.7h4.8v-6.1h-4.8V222.7z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,242.2h4.8v-8.3h-4.8V242.2z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,246.2h4.8v-3.9h-4.8V246.2z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,267.9h4.8v-10.5h-4.8V267.9z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,269.6h4.8v-1.7h-4.8V269.6z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,291.7h4.8v-9.1h-4.8V291.7z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,282.6h4.8v-3.1h-4.8V282.6z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,315.2h4.8v-6.9h-4.8V315.2z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1591,308.3h4.8v-5.3h-4.8V308.3z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,191h4.8V187h-4.8V191z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,199.3h4.8V191h-4.8V199.3z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,216.6h4.8v-6.1h-4.8V216.6z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,222.7h4.8v-6.1h-4.8V222.7z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,242.2h4.8v-8.3h-4.8V242.2z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,246.2h4.8v-3.9h-4.8V246.2z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,267.9h4.8v-10.5h-4.8V267.9z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,269.6h4.8v-1.7h-4.8V269.6z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,291.7h4.8v-9.1h-4.8V291.7z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,282.6h4.8v-3.1h-4.8V282.6z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,315.2h4.8v-6.9h-4.8V315.2z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1611.8,308.3h4.8v-5.3h-4.8V308.3z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1556.8,205.7h-9.7V191h2.4v8.3h4.8V191h2.4V205.7z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1577.6,205.7h-9.7V191h2.4v8.3h4.8V191h2.4V205.7z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1588.6,205.7h9.7V191h-9.7V205.7z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1619,205.7h-9.7V191h2.4v8.3h4.8V191h2.4V205.7z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1547.2,231.3h9.7v-14.7h-9.7V231.3z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1567.9,231.3h9.7v-14.7h-9.7V231.3z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1598.3,231.3h-9.7v-14.7h2.4v6.1h4.8v-6.1h2.4V231.3z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1619,231.3h-9.7v-14.7h2.4v6.1h4.8v-6.1h2.4V231.3z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1556.8,257h-9.7v-14.7h2.4v3.9h4.8v-3.9h2.4V257z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1577.6,257h-9.7v-14.7h2.4v3.9h4.8v-3.9h2.4V257z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1598.3,257h-9.7v-14.7h2.4v3.9h4.8v-3.9h2.4V257z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1609.3,257h9.7v-14.7h-9.7V257z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1556.8,282.6h-2.4v-3.1h-4.8v3.1h-2.4v-14.7h2.4v1.7h4.8v-1.7h2.4V282.6z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1567.9,282.6h9.7v-14.7h-9.7V282.6z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1598.3,282.6h-2.4v-3.1h-4.8v3.1h-2.4v-14.7h2.4v1.7h4.8v-1.7h2.4V282.6z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1619,282.6h-2.4v-3.1h-4.8v3.1h-2.4v-14.7h2.4v1.7h4.8v-1.7h2.4V282.6z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1556.8,308.3h-2.4v-5.3h-4.8v5.3h-2.4v-14.7h9.7V308.3z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1577.6,308.3h-2.4v-5.3h-4.8v5.3h-2.4v-14.7h9.7V308.3z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1588.6,308.3h9.7v-14.7h-9.7V308.3z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1619,308.3h-2.4v-5.3h-4.8v5.3h-2.4v-14.7h9.7V308.3z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1556.8,333.9h-9.7v-14.7h9.7V333.9z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1577.6,333.9h-9.7v-14.7h9.7V333.9z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1588.6,333.9h9.7v-14.7h-9.7V333.9z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1609.3,333.9h9.7v-14.7h-9.7V333.9z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1547.2,359.5h9.7v-14.7h-9.7V359.5z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1577.6,359.5h-9.7v-14.7h9.7V359.5z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1588.6,359.5h9.7v-14.7h-9.7V359.5z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1619,359.5h-9.7v-14.7h9.7V359.5z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.7,388h39.6V263.4h-39.6V388z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.7,388h-43.2v-98.3h43.2V388z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237,273.4h17.5v-15.1H237V273.4z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.5,291.7h-46V288h46V291.7z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M446,388H293v-56h153V388z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.9,388h-39.4V286.1h39.4V388z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M154.2,388h-51.8v-50.4h51.8V388z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.7,388H45.3v-58.9h32.4V388z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.1,388H71.5v-17.5h76.6V388z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.3,388H0v-23.6h55.3V388z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237,388h-61v-36.7h61V388z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M338.2,208v2h-2v5.6H371V388H314V224.5v-9v-5.6H312v-2H338.2z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M450,388H355v-15H450V388z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M618.6,388h-95.1v-15h95.1V388z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M446.3,324.8h-36.1l-15.3,56.4h51.4V324.8z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M464,305.3h-1v-62.6h1V305.3z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M469.4,300.8h-1.3v-36.9h1.3V300.8z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M479.2,288.7h-18.3v-18.3h18.3V288.7z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M482,270.6h-24.2V269H482V270.6z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M534.2,388h-59.1v-51.5h59.1V388z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M560.8,278.3h-37.9v102h37.9V278.3z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M484,388h-48.8V286.9H484V388z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M731.7,388h-60.6v-90.5h60.6V388z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M721.2,388h-69.1v-32.5h69.1V388z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M728.3,388h45v-10.7h-45V388z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M870.7,355.5h-73.1V388h73.1V355.5z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M826.7,388h90.9V266.9h-90.9V388z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M824.4,266.9H923v-4.7h-98.6V266.9z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M873.7,274.3h40v-24.8h-40V274.3z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M853.9,264.6h6.7v-15.1h-6.7V264.6z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M839.8,264.6h7.4v-15.1h-7.4V264.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1358,
    y: 71,
    width: 254,
    height: 246
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122695575468209778930000005920078932877446318_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122695575468209778930000005920078932877446318_)"
    }
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1550.1,228.1h61.9v7.9h-61.9V228.1z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1555.6,229.9c0.1,0,0.2-0.1,0.3-0.2l25.2-30.8l25.1,30.8c0.2,0.2,0.4,0.2,0.6,0.1c0.2-0.1,0.2-0.4,0.1-0.6 l-25.5-31.2c-0.2-0.2-0.5-0.2-0.7,0l-25.5,31.2c-0.2,0.2-0.1,0.5,0.1,0.6C1555.4,229.9,1555.4,229.9,1555.6,229.9L1555.6,229.9z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1375.3,101.8h-8.5c-1.7,0-3,1.4-3,3v2.6h14.5v-2.6C1378.3,103.1,1377,101.8,1375.3,101.8L1375.3,101.8z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1425.9,74.8l118.7,28.3l-0.2,0.8l-118.7-28.3L1425.9,74.8z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1416.3,134.8h14.9c0.5,0,0.9-0.4,0.9-0.9v-7.1c0-0.5-0.4-0.9-0.9-0.9h-14.9c-0.5,0-0.9,0.4-0.9,0.9v7.1 C1415.5,134.4,1415.9,134.8,1416.3,134.8z M1430.4,133.1h-13.2v-5.4h13.2V133.1z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1439.7,314.2h-28.1v-18.9c0-2.4,1.9-4.3,4.3-4.3h19.5c2.4,0,4.3,1.9,4.3,4.3V314.2"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1447.8,319.5h-44.2v-2.3c0-1.7,1.3-3,3-3h38.2c1.7,0,3,1.4,3,3V319.5"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,115.9H1601c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-167.4l10.8-9.3h150.3 c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9h-150.6c-0.2,0-0.4,0.1-0.6,0.2l-12.8,11.1c-0.3,0.2-0.4,0.6-0.2,1 C1430.6,115.7,1430.9,115.9,1431.2,115.9L1431.2,115.9z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1450.3,115.9c0.2,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1449.7,115.7,1450,115.9,1450.3,115.9z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1450.3,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1450.1,115.9,1450.2,115.9,1450.3,115.9z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1462.9,115.9c0.1,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1462.3,115.7,1462.6,115.9,1462.9,115.9z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1462.9,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1462.6,115.9,1462.7,115.9,1462.9,115.9z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1475.4,115.9c0.2,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1474.8,115.7,1475.1,115.9,1475.4,115.9z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1475.4,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1475.2,115.9,1475.3,115.9,1475.4,115.9z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1488,115.9c0.2,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1487.4,115.7,1487.7,115.9,1488,115.9z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1488,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1487.7,115.9,1487.8,115.9,1488,115.9z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1500.6,115.9c0.1,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1500,115.7,1500.2,115.9,1500.6,115.9z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1500.6,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2s-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1500.3,115.9,1500.4,115.9,1500.6,115.9z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1513.1,115.9c0.1,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1512.5,115.7,1512.8,115.9,1513.1,115.9z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1513.1,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1512.8,115.9,1513,115.9,1513.1,115.9z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1525.7,115.9c0.1,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1525.1,115.7,1525.3,115.9,1525.7,115.9z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1525.7,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1525.4,115.9,1525.5,115.9,1525.7,115.9z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1538.2,115.9c0.1,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1537.6,115.7,1537.9,115.9,1538.2,115.9z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1538.2,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1537.9,115.9,1538.1,115.9,1538.2,115.9z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1550.8,115.9c0.2,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1550.2,115.7,1550.5,115.9,1550.8,115.9z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1550.8,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1550.5,115.9,1550.6,115.9,1550.8,115.9z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1563.3,115.9c0.1,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1562.7,115.7,1563,115.9,1563.3,115.9z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1563.3,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1563,115.9,1563.2,115.9,1563.3,115.9z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1575.9,115.9c0.1,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1575.3,115.7,1575.6,115.9,1575.9,115.9z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1575.9,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1575.6,115.9,1575.7,115.9,1575.9,115.9z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1588.4,115.9c0.1,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 c-0.4,0.2-0.6,0.8-0.3,1.2l6.3,11.1C1587.8,115.7,1588.1,115.9,1588.4,115.9z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1588.4,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1588.1,115.9,1588.3,115.9,1588.4,115.9z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1588.4,115.9c0.3,0,0.6-0.2,0.8-0.4l6.3-11.1c0.2-0.4,0.1-0.9-0.3-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-6.3,11.1 c-0.2,0.4-0.1,0.9,0.3,1.2C1588.1,115.9,1588.3,115.9,1588.4,115.9z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1601,115.9c0.2,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.8,0.3-1.2l-6.3-11.1c-0.2-0.4-0.8-0.6-1.2-0.3 s-0.6,0.8-0.3,1.2l6.3,11.1C1600.4,115.7,1600.7,115.9,1601,115.9z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1379.7,121.6h-13.4c-1.7,0-3-1.4-3-3V115h19.4v3.6C1382.8,120.3,1381.4,121.6,1379.7,121.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1375.3,101.8h-8.5c-1.7,0-3,1.4-3,3v2.6h14.5v-2.6C1378.3,103.1,1377,101.8,1375.3,101.8L1375.3,101.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1379.7,121.6h-13.4c-1.7,0-3-1.4-3-3V115h19.4v3.6C1382.8,120.3,1381.4,121.6,1379.7,121.6z"
  }))), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,291.8h11c0.5,0,0.9-0.4,0.9-0.9V115c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.8,0.4-0.8,0.9v175h-9.3V121.3 c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v169.6C1419.3,291.4,1419.7,291.8,1420.2,291.8z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,273c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,272.8,1419.9,273,1420.2,273z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,266.7c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,266.6,1431.1,266.7,1431.2,266.7z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,260.4c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,260.2,1419.9,260.4,1420.2,260.4z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,254.1c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,254.1,1431.1,254.1,1431.2,254.1z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,291.8c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,291.8,1431.1,291.8,1431.2,291.8z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,285.5c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,285.4,1419.9,285.5,1420.2,285.5z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,279.2c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,279.2,1431.1,279.2,1431.2,279.2z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,247.8c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,247.7,1419.9,247.8,1420.2,247.8z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,241.5c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,241.5,1431.1,241.5,1431.2,241.5z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,235.3c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,235.1,1419.9,235.3,1420.2,235.3z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,229c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,228.9,1431.1,229,1431.2,229z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,222.7c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,222.5,1419.9,222.7,1420.2,222.7z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,216.4c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,216.4,1431.1,216.4,1431.2,216.4z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,210.1c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,210,1419.9,210.1,1420.2,210.1z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,203.8c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,203.8,1431.1,203.8,1431.2,203.8z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,197.6c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,197.4,1419.9,197.6,1420.2,197.6z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,191.3c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,191.2,1431.1,191.3,1431.2,191.3z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,185c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,184.8,1419.9,185,1420.2,185z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,178.7c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,178.7,1431.1,178.7,1431.2,178.7z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,172.4c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,172.3,1419.9,172.4,1420.2,172.4z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,166.2c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,166.1,1431.1,166.2,1431.2,166.2z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,159.9c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,159.7,1419.9,159.9,1420.2,159.9z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,153.6c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,153.6,1431.1,153.6,1431.2,153.6z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,147.3c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,147.1,1419.9,147.3,1420.2,147.3z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,141c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,141,1431.1,141,1431.2,141z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,134.7c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,134.6,1419.9,134.7,1420.2,134.7z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,128.5c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,128.4,1431.1,128.5,1431.2,128.5z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1431.2,128.5c0.3,0,0.6-0.2,0.8-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-11.1-6.3c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l11.1,6.3C1430.9,128.4,1431.1,128.5,1431.2,128.5z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,122.2c0.1,0,0.3,0,0.4-0.1l11.1-6.3c0.4-0.2,0.6-0.8,0.3-1.2c-0.2-0.4-0.8-0.6-1.2-0.3l-11.1,6.3 c-0.4,0.2-0.6,0.8-0.3,1.2C1419.6,122,1419.9,122.2,1420.2,122.2z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,122.2h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,121.8,1419.7,122.2,1420.2,122.2z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,134.7h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,134.4,1419.7,134.7,1420.2,134.7z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,147.3h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,146.9,1419.7,147.3,1420.2,147.3z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,159.9h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,159.5,1419.7,159.9,1420.2,159.9z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,172.4h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,172,1419.7,172.4,1420.2,172.4z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,185h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,184.6,1419.7,185,1420.2,185z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,197.6h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,197.2,1419.7,197.6,1420.2,197.6z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,210.1h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,209.7,1419.7,210.1,1420.2,210.1z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,222.7h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,222.3,1419.7,222.7,1420.2,222.7z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,235.3h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,234.9,1419.7,235.3,1420.2,235.3z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,247.8h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,247.4,1419.7,247.8,1420.2,247.8z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,260.4h11c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 S1419.7,260.4,1420.2,260.4z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,273h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,272.6,1419.7,273,1420.2,273z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,122.2c0.5,0,0.9-0.4,0.9-0.9V115c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v6.3 C1419.3,121.8,1419.7,122.2,1420.2,122.2z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,115.9h11c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-11c-0.5,0-0.9,0.4-0.9,0.9 C1419.3,115.5,1419.7,115.9,1420.2,115.9z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1420.2,115.9h11c0.2,0,0.5-0.1,0.7-0.3c0.2-0.2,0.2-0.4,0.2-0.7l-5.1-39.5c-0.1-0.6-0.6-1.1-1.3-1.1 c-0.7,0-1.2,0.5-1.3,1.1l-5.1,39.5c0,0.2,0,0.5,0.2,0.7C1419.7,115.8,1419.9,115.9,1420.2,115.9L1420.2,115.9z M1430.3,114.2h-9.1 l4.5-35.2L1430.3,114.2z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1430.8,112.2c0.3,0,0.6-0.2,0.8-0.5c0.2-0.4,0-0.9-0.4-1.2l-9.5-4.7c-0.4-0.2-0.9,0-1.2,0.4 c-0.2,0.4,0,0.9,0.4,1.2l9.5,4.7C1430.5,112.2,1430.6,112.2,1430.8,112.2z"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1421.3,107.5c0.2,0,0.4-0.1,0.5-0.2l8.1-6.3c0.4-0.3,0.4-0.8,0.2-1.2c-0.3-0.4-0.8-0.4-1.2-0.1l-8.1,6.3 c-0.4,0.3-0.4,0.8-0.2,1.2C1420.8,107.3,1421,107.5,1421.3,107.5z"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1429.3,101.1c0.3,0,0.6-0.1,0.7-0.4c0.2-0.4,0.1-0.9-0.3-1.2l-6.7-4.1c-0.4-0.2-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l6.7,4.1C1429,101.1,1429.2,101.1,1429.3,101.1z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1422.6,97c0.2,0,0.4-0.1,0.6-0.2l0.3-0.2l5.3-4.6c0.4-0.3,0.4-0.8,0.1-1.2c-0.3-0.4-0.8-0.4-1.2-0.1l-0.1,0 l-5.5,4.8c-0.4,0.3-0.4,0.9-0.1,1.2C1422.1,96.9,1422.4,97,1422.6,97z"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1428.2,92.2c0.3,0,0.5-0.1,0.7-0.4c0.3-0.4,0.2-0.9-0.2-1.2l-0.1-0.1l-4.5-3c-0.4-0.3-0.9-0.1-1.2,0.3 c-0.2,0.4-0.1,0.9,0.3,1.2l0.2,0.1l4.3,2.9C1427.8,92.2,1428,92.2,1428.2,92.2z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1427.3,85.7c0.2,0,0.4-0.1,0.5-0.2c0.4-0.3,0.4-0.8,0.2-1.2l-2.8-3.6c-0.3-0.4-0.8-0.4-1.2-0.1 c-0.4,0.3-0.4,0.8-0.2,1.2l2.8,3.6C1426.8,85.6,1427.1,85.8,1427.3,85.7L1427.3,85.7z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1423.6,89.1c0.2,0,0.4-0.1,0.6-0.2l0.1-0.1l3.6-3.3c0.3-0.3,0.4-0.9,0.1-1.2c-0.3-0.4-0.9-0.4-1.2-0.1 l-3.7,3.3c-0.4,0.3-0.4,0.9-0.1,1.2C1423.2,89,1423.4,89.1,1423.6,89.1L1423.6,89.1z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1437.8,133.5h-6.2c-1.7,0-3.1-1.4-3.1-3.1v-9.9c0-1.8,1.5-3.2,3.2-3.1l4.7,0.1c0.7,0,1.3,0.3,1.8,0.7 l1.4,1.1c1.6,1.2,2.6,3,2.9,5l0.5,3.3C1443.4,130.7,1441,133.5,1437.8,133.5z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1437.8,133.5h-6.2c-1.7,0-3.1-1.4-3.1-3.1v-9.9c0-1.8,1.5-3.2,3.2-3.1l4.7,0.1c0.7,0,1.3,0.3,1.8,0.7 l1.4,1.1c1.6,1.2,2.6,3,2.9,5l0.5,3.3C1443.4,130.7,1441,133.5,1437.8,133.5z"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1417.1,115.9h3.1c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-3.1c-0.5,0-0.9,0.4-0.9,0.9 C1416.2,115.5,1416.6,115.9,1417.1,115.9z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1435.7,126.8h4.7c0.5,0,0.8,0.4,0.8,0.8v0.3c0,1.2-0.5,2.4-1.5,3.3c-0.5,0.4-1.1,0.7-1.8,0.7h-2 c-0.6,0-1.1-0.5-1.1-1.1v-3.1C1434.9,127.2,1435.2,126.8,1435.7,126.8z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1435.7,125.8h4.3c0.5,0,0.8-0.4,0.8-0.8v-0.3c0-1.2-0.5-2.4-1.5-3.3c-0.5-0.4-1.1-0.7-1.8-0.7h-1.6 c-0.6,0-1.1,0.5-1.1,1.1v3.1C1434.9,125.4,1435.2,125.8,1435.7,125.8z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1425.1,74.8l0.5,0.7l-47,31.8l-0.5-0.7L1425.1,74.8z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1427.8,76.9h-4.1c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7h4.1c0.9,0,1.7,0.8,1.7,1.7 S1428.8,76.9,1427.8,76.9z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1358.9,115.9h58.2c0.5,0,0.9-0.4,0.9-0.9V107c0-0.5-0.4-0.9-0.9-0.9h-58.2c-0.5,0-0.9,0.4-0.9,0.9v8.1 C1358,115.5,1358.4,115.9,1358.9,115.9z M1416.2,114.2h-56.5v-6.4h56.5V114.2z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1358.9,113.2h61.6c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-61.6c-0.5,0-0.9,0.4-0.9,0.9 C1358,112.8,1358.4,113.2,1358.9,113.2z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1407.4,113.2c0.5,0,0.9-0.4,0.9-0.9V107c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v5.4 C1406.5,112.8,1406.9,113.2,1407.4,113.2z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1417.1,112.9c0.5,0,0.9-0.4,0.9-0.9V107c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v5.1 C1416.2,112.5,1416.6,112.9,1417.1,112.9z"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1397.7,113.2c0.5,0,0.9-0.4,0.9-0.9V107c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v5.4 C1396.8,112.8,1397.2,113.2,1397.7,113.2z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1388,113.2c0.5,0,0.9-0.4,0.9-0.9V107c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v5.4 C1387.1,112.8,1387.5,113.2,1388,113.2z"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1378.3,113.2c0.5,0,0.9-0.4,0.9-0.9V107c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v5.4 C1377.4,112.8,1377.8,113.2,1378.3,113.2z"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1368.6,113.2c0.5,0,0.9-0.4,0.9-0.9V107c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v5.4 C1367.7,112.8,1368.1,113.2,1368.6,113.2z"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1358.9,112.9c0.5,0,0.9-0.4,0.9-0.9V107c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v5.1 C1358,112.5,1358.4,112.9,1358.9,112.9z"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1358.9,110.5h61.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-61.9c-0.5,0-0.9,0.4-0.9,0.9 C1358,110.1,1358.4,110.5,1358.9,110.5z"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1411.7,295.4h28.1v0.4h-28.1v-0.2h28.1h-28.1V295.4z"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1411.7,300h28.1v0.4h-28.1v-0.2h28.1h-28.1V300z"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1411.7,304.7h28.1v0.4h-28.1v-0.2h28.1h-28.1V304.7z"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1411.7,309.3h28.1v0.4h-28.1v-0.2h28.1h-28.1V309.3z"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1411.7,314h28.1v0.2h-28.1V314z"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1411.7,314.2h28.1v0.2h-28.1V314.2z"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1542,104c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1579.5,184.9h3.1l3-68.3h-9.2L1579.5,184.9z M1581.8,184h-1.5l-3-66.6h7.4L1581.8,184z"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1581,199.8c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9 c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9 C1577.9,198.4,1579.3,199.8,1581,199.8L1581,199.8z"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1581,195.3c0.5,0,0.9-0.4,0.9-0.9v-3.3c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v3.3 C1580.2,194.9,1580.6,195.3,1581,195.3z"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1582.5,192.4h-2.9c-0.4,0-0.8-0.3-0.8-0.6l-1.5-5.5h7.5l-1.5,5.5C1583.3,192.2,1582.9,192.4,1582.5,192.4 L1582.5,192.4z"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1584.8,186.4c0-2.1-1.7-3.8-3.8-3.8c-2.1,0-3.8,1.7-3.8,3.8"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1586.4,119h-10.7c-0.9,0-1.7-0.8-1.7-1.7V115h14.1v2.3C1588.1,118.3,1587.3,119,1586.4,119L1586.4,119z"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1416.3,131.2h3.8c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-3.8c-0.5,0-0.9,0.4-0.9,0.9 C1415.5,130.8,1415.9,131.2,1416.3,131.2z"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1417,107.8h3.3c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9h-3.3c-0.5,0-0.9,0.4-0.9,0.9 S1416.5,107.8,1417,107.8z"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1430.1,104.8h20.6c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9h-20.6c-0.5,0-0.9,0.4-0.9,0.9 S1429.6,104.8,1430.1,104.8z"
  })))), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M980.2,388h72V210.5h-72V388z"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M978.1,212.5h76.1v-5.1h-76.1V212.5z"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M982.6,225h67.1v-24h-67.1V225z"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1018,217.4h26.6v-26.3H1018V217.4z"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1029.2,198.5h15.4v-13.8h-11L1029.2,198.5z"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1038.4,204h-1.5v-30.8h1.5V204z"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1036.3,171.6c0,0.9,0.6,1.6,1.3,1.6s1.3-0.7,1.3-1.6c0-0.9-0.6-1.6-1.3-1.6S1036.3,170.8,1036.3,171.6z"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1074.5,388h-32.2v-72.5h32.2V388z"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M950.5,279.5h36.7V388h-36.7V279.5z"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M968.9,388h-51.8v-57.4l43.7,18.9L968.9,388z"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1143,388h-79v-30.5h79V388z"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1113.8,388h45.9V262h-45.9V388z"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1161.8,263.9h-50.4v-4.2h50.4V263.9z"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1152.5,241.7h1v25.7h-1V241.7z"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1146.8,265.5h-1V245h1V265.5z"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1176.7,310h-20.5v58.4h29.2L1176.7,310z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000108280966383216870890000008517243059922476430_",
    x: 1319,
    y: 0,
    width: 117,
    height: 363
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161624155529958258250000011529266315059653277_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108280966383216870890000008517243059922476430_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000161624155529958258250000011529266315059653277_)"
    }
  }, _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1430.5,363c3.6-37,0-79.9,0-126.4c0-128.1-20.2-219.1-52.5-219.1s-53.5,88.4-53.5,219.1 c0,46.5-2.2,89.9,3.5,126.4H1430.5z"
  })))), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1380.6,363.4h72V184.5h-72V363.4z"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1378.6,186.4h76.1v-5.1h-76.1V186.4z"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1383.1,199h67.1v-24h-67.1V199z"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1418.5,191.3h26.6v-26.3h-26.6V191.3z"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1429.7,172.5h15.4v-13.8h-11L1429.7,172.5z"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1438.9,178h-1.5v-30.8h1.5V178z"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1436.8,145.6c0,0.9,0.6,1.6,1.3,1.6s1.3-0.7,1.3-1.6c0-0.9-0.6-1.6-1.3-1.6S1436.8,144.7,1436.8,145.6z"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1475,363.4h-32.2v-73.9h32.2V363.4z"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1674,388h-531v-26h531V388z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000032625590023892662980000010341469940399943869_",
    x: 647,
    y: 93,
    width: 309,
    height: 297.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156571910946516231710000016504356275384299410_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032625590023892662980000010341469940399943869_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000156571910946516231710000016504356275384299410_)"
    }
  }, _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M722.3,283.1H647v9.5h75.3V283.1z"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M715.7,285.4c-0.2,0-0.3-0.1-0.4-0.2l-30.6-37.3l-30.6,37.3c-0.2,0.2-0.5,0.3-0.7,0.1 c-0.2-0.2-0.3-0.5-0.1-0.7l31-37.8c0.2-0.2,0.6-0.2,0.8,0l31,37.8c0.2,0.2,0.1,0.6-0.1,0.7C715.9,285.3,715.8,285.4,715.7,285.4 L715.7,285.4z"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M935,130.2h10.3c2,0,3.7,1.6,3.7,3.6v3.2h-17.7v-3.2C931.3,131.9,932.9,130.2,935,130.2L935,130.2z"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M873.4,97.6L729,131.9l0.2,1l144.4-34.3L873.4,97.6z"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M885,170.2h-18.1c-0.6,0-1-0.5-1-1v-8.6c0-0.6,0.5-1,1-1H885c0.6,0,1,0.5,1,1v8.6 C886.1,169.7,885.6,170.2,885,170.2z M867.9,168.1h16v-6.5h-16V168.1z"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M856.6,387.4h34.1v-22.9c0-2.9-2.3-5.2-5.2-5.2h-23.7c-2.9,0-5.2,2.3-5.2,5.2L856.6,387.4"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,147.3H660.4c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h203.7L850.9,134H668c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1 h183.3c0.3,0,0.5,0.1,0.7,0.3l15.6,13.4c0.3,0.3,0.4,0.7,0.3,1.2C867.7,147.1,867.3,147.4,866.9,147.3L866.9,147.3z"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M843.7,147.3c-0.2,0-0.3,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C844.4,147.2,844,147.3,843.7,147.3z"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M843.7,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C844,147.3,843.8,147.3,843.7,147.3z"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M828.4,147.3c-0.2,0-0.3,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C829.1,147.2,828.8,147.3,828.4,147.3z"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M828.4,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C828.8,147.3,828.6,147.3,828.4,147.3z"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M813.1,147.3c-0.2,0-0.3,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C813.8,147.2,813.5,147.3,813.1,147.3z"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M813.1,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C813.5,147.3,813.3,147.3,813.1,147.3z"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M797.9,147.3c-0.2,0-0.4,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C798.6,147.2,798.2,147.3,797.9,147.3z"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M797.9,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C798.2,147.3,798,147.3,797.9,147.3z"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M782.6,147.3c-0.2,0-0.4,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C783.3,147.2,782.9,147.3,782.6,147.3z"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M782.6,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C782.9,147.3,782.8,147.3,782.6,147.3z"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M767.3,147.3c-0.2,0-0.4,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C768,147.2,767.7,147.3,767.3,147.3z"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M767.3,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C767.7,147.3,767.5,147.3,767.3,147.3z"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M752,147.3c-0.2,0-0.3,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C752.8,147.2,752.4,147.3,752,147.3z"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M752,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C752.4,147.3,752.2,147.3,752,147.3z"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M736.8,147.3c-0.2,0-0.4,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C737.5,147.2,737.1,147.3,736.8,147.3z"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M736.8,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C737.1,147.3,736.9,147.3,736.8,147.3z"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M721.5,147.3c-0.2,0-0.4,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C722.2,147.2,721.9,147.3,721.5,147.3z"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M721.5,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C721.8,147.3,721.7,147.3,721.5,147.3z"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M706.2,147.3c-0.2,0-0.4,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C706.9,147.2,706.6,147.3,706.2,147.3z"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M706.2,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C706.6,147.3,706.4,147.3,706.2,147.3z"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M691,147.3c-0.2,0-0.4,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C691.7,147.2,691.3,147.3,691,147.3z"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M691,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C691.3,147.3,691.1,147.3,691,147.3z"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M675.7,147.3c-0.2,0-0.4,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C676.4,147.2,676,147.3,675.7,147.3z"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M675.7,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C676,147.3,675.9,147.3,675.7,147.3z"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M675.7,147.3c-0.4,0-0.7-0.2-0.9-0.5l-7.6-13.4c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.6,13.4 c0.3,0.5,0.1,1.1-0.4,1.4C676,147.3,675.9,147.3,675.7,147.3z"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M660.4,147.3c-0.2,0-0.4,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l7.6-13.4c0.3-0.5,0.9-0.7,1.4-0.4 c0.5,0.3,0.7,0.9,0.4,1.4l-7.6,13.4C661.1,147.2,660.8,147.3,660.4,147.3z"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M929.6,154.3h16.3c2,0,3.7-1.6,3.7-3.6v-4.3h-23.6v4.3C925.9,152.7,927.5,154.3,929.6,154.3z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M935,130.2h10.3c2,0,3.7,1.6,3.7,3.6v3.2h-17.7v-3.2C931.3,131.9,932.9,130.2,935,130.2L935,130.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M929.6,154.3h16.3c2,0,3.7-1.6,3.7-3.6v-4.3h-23.6v4.3C925.9,152.7,927.5,154.3,929.6,154.3z"
  }))), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,360.3h-13.5c-0.6,0-1-0.5-1-1v-213c0-0.6,0.5-1,1-1s1,0.5,1,1v211.9h11.4V153.9c0-0.6,0.5-1,1-1 c0.6,0,1,0.5,1,1v205.4C881.4,359.8,880.9,360.3,880.4,360.3z"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,337.5c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,337.3,880.7,337.5,880.4,337.5z"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,329.9c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,329.8,867.1,329.9,866.9,329.9z"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,322.3c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,322.1,880.7,322.3,880.4,322.3z"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,314.7c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,314.6,867.1,314.7,866.9,314.7z"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,360.3c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,360.3,867.1,360.3,866.9,360.3z"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,352.7c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,352.5,880.7,352.7,880.4,352.7z"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,345.1c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,345.1,867.1,345.1,866.9,345.1z"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,307.1c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,306.9,880.7,307.1,880.4,307.1z"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,299.5c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,299.4,867.1,299.5,866.9,299.5z"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,291.9c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,291.7,880.7,291.9,880.4,291.9z"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,284.2c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,284.2,867.1,284.2,866.9,284.2z"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,276.6c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,276.5,880.7,276.6,880.4,276.6z"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,269c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,269,867.1,269,866.9,269z"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,261.4c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,261.2,880.7,261.4,880.4,261.4z"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,253.8c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,253.8,867.1,253.8,866.9,253.8z"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,246.2c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,246,880.7,246.2,880.4,246.2z"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,238.6c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,238.6,867.1,238.6,866.9,238.6z"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,231c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,230.8,880.7,231,880.4,231z"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,223.4c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,223.4,867.1,223.4,866.9,223.4z"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,215.8c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,215.6,880.7,215.8,880.4,215.8z"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,208.2c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,208.1,867.1,208.2,866.9,208.2z"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,200.6c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,200.4,880.7,200.6,880.4,200.6z"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,193c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,192.9,867.1,193,866.9,193z"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,185.4c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,185.2,880.7,185.4,880.4,185.4z"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,177.8c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,177.7,867.1,177.8,866.9,177.8z"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,170.2c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,170,880.7,170.2,880.4,170.2z"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,162.6c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,162.5,867.1,162.6,866.9,162.6z"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M866.9,162.6c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l13.5-7.6c0.5-0.3,1.1-0.1,1.4,0.4 c0.3,0.5,0.1,1.1-0.4,1.4l-13.5,7.6C867.3,162.5,867.1,162.6,866.9,162.6z"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,155c-0.2,0-0.3,0-0.5-0.1l-13.5-7.6c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l13.5,7.6 c0.5,0.3,0.7,0.9,0.4,1.4C881.1,154.8,880.7,155,880.4,155z"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,154.9h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,154.5,880.9,154.9,880.4,154.9z"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,170.2h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,169.7,880.9,170.2,880.4,170.2z"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,185.4h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,184.9,880.9,185.4,880.4,185.4z"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,200.6h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,200.1,880.9,200.6,880.4,200.6z"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,215.8h-13.5c-0.6,0-1-0.5-1-1s0.5-1,1-1h13.5c0.6,0,1,0.5,1,1S880.9,215.8,880.4,215.8z"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,231h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1C881.4,230.5,880.9,231,880.4,231z"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,246.2h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,245.7,880.9,246.2,880.4,246.2z"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,261.4h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,261,880.9,261.4,880.4,261.4z"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,276.6h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,276.2,880.9,276.6,880.4,276.6z"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,291.9h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,291.4,880.9,291.9,880.4,291.9z"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,307.1h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,306.6,880.9,307.1,880.4,307.1z"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,322.3h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,321.8,880.9,322.3,880.4,322.3z"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,337.5h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,337,880.9,337.5,880.4,337.5z"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,154.9c-0.6,0-1-0.5-1-1v-7.6c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1v7.6 C881.4,154.5,880.9,154.9,880.4,154.9z"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,147.3h-13.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.5c0.6,0,1,0.5,1,1 C881.4,146.9,880.9,147.3,880.4,147.3z"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.4,147.3h-13.5c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.2-0.3-0.5-0.3-0.8l6.2-47.9c0.1-0.7,0.7-1.3,1.5-1.3 s1.5,0.5,1.5,1.3l6.2,47.9c0,0.3-0.1,0.6-0.3,0.8C880.9,147.2,880.7,147.3,880.4,147.3L880.4,147.3z M868.1,145.3h11.1l-5.5-42.6 L868.1,145.3z"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M867.5,142.9c-0.4,0-0.8-0.2-0.9-0.6c-0.3-0.5,0-1.1,0.5-1.4l11.6-5.7c0.5-0.3,1.1,0,1.4,0.5 c0.3,0.5,0,1.1-0.5,1.4l-11.6,5.7C867.8,142.8,867.6,142.9,867.5,142.9z"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M879,137.1c-0.2,0-0.5-0.1-0.6-0.2l-9.8-7.7c-0.5-0.4-0.5-1-0.2-1.5c0.4-0.5,1-0.5,1.5-0.2l9.8,7.7 c0.5,0.4,0.5,1,0.2,1.5C879.6,137,879.3,137.1,879,137.1z"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M869.2,129.5c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.3-1.4l8.2-4.9c0.5-0.3,1.1-0.1,1.4,0.3 c0.3,0.5,0.1,1.1-0.4,1.4l-8.2,4.9C869.6,129.4,869.4,129.5,869.2,129.5z"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M877.4,124.5c-0.2,0-0.5-0.1-0.7-0.3l-0.3-0.3l-6.4-5.6c-0.4-0.4-0.5-1-0.1-1.5c0.4-0.4,1-0.5,1.5-0.1 l0.1,0.1l6.7,5.8c0.4,0.4,0.5,1,0.1,1.5C878,124.4,877.7,124.5,877.4,124.5z"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M870.6,118.7c-0.3,0-0.7-0.2-0.9-0.4c-0.3-0.5-0.2-1.1,0.3-1.5l0.1-0.1l5.4-3.7c0.5-0.3,1.1-0.2,1.4,0.3 c0.3,0.5,0.2,1.1-0.3,1.4l-0.2,0.2l-5.2,3.6C871,118.6,870.8,118.7,870.6,118.7z"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M871.6,110.9c-0.2,0-0.4-0.1-0.6-0.2c-0.5-0.4-0.5-1-0.2-1.5l3.4-4.4c0.4-0.5,1-0.5,1.5-0.2 c0.5,0.4,0.5,1,0.2,1.5l-3.4,4.4C872.3,110.7,872,110.9,871.6,110.9L871.6,110.9z"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M876.1,114.9c-0.2,0-0.5-0.1-0.7-0.2l-0.2-0.1l-4.4-4c-0.4-0.4-0.5-1-0.1-1.5c0.4-0.4,1.1-0.5,1.5-0.1l4.5,4 c0.4,0.4,0.5,1,0.1,1.5C876.7,114.8,876.4,114.9,876.1,114.9L876.1,114.9z"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M858.9,168.6h7.6c2.1,0,3.8-1.7,3.8-3.8v-12c0-2.1-1.8-3.9-3.9-3.8l-5.7,0.2c-0.8,0-1.6,0.3-2.2,0.8l-1.7,1.3 c-1.9,1.5-3.2,3.7-3.6,6.1l-0.6,4C852.1,165.2,855.1,168.6,858.9,168.6z"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M858.9,168.6h7.6c2.1,0,3.8-1.7,3.8-3.8v-12c0-2.1-1.8-3.9-3.9-3.8l-5.7,0.2c-0.8,0-1.6,0.3-2.2,0.8l-1.7,1.3 c-1.9,1.5-3.2,3.7-3.6,6.1l-0.6,4C852.1,165.2,855.1,168.6,858.9,168.6z"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M884.1,147.3h-3.7c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h3.7c0.6,0,1,0.5,1,1 C885.1,146.9,884.7,147.3,884.1,147.3z"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M861.5,160.5h-5.7c-0.6,0-1,0.5-1,1v0.3c0,1.5,0.7,2.9,1.8,3.9c0.6,0.5,1.4,0.8,2.2,0.8h2.4 c0.8,0,1.4-0.6,1.4-1.4v-3.7C862.5,161,862,160.5,861.5,160.5z"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M861.5,159.4h-5.2c-0.6,0-1-0.5-1-1V158c0-1.5,0.7-2.9,1.8-3.9c0.6-0.5,1.4-0.8,2.2-0.8h1.9 c0.8,0,1.4,0.6,1.4,1.4v3.7C862.5,158.9,862,159.4,861.5,159.4z"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M874.4,97.6l-0.6,0.9l57.2,38.5l0.6-0.9L874.4,97.6z"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M871,100.1h5c1.2,0,2.1-0.9,2.1-2.1c0-1.1-0.9-2.1-2.1-2.1h-5c-1.1,0-2.1,0.9-2.1,2.1 C869,99.2,869.9,100.1,871,100.1z"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M954.9,147.3h-70.9c-0.6,0-1-0.5-1-1v-9.8c0-0.6,0.5-1,1-1h70.9c0.6,0,1,0.5,1,1v9.8 C956,146.9,955.5,147.3,954.9,147.3z M885.1,145.3h68.8v-7.7h-68.8V145.3z"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M954.9,144.1H880c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h74.9c0.6,0,1,0.5,1,1C956,143.6,955.5,144.1,954.9,144.1z "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M895.9,144.1c-0.6,0-1-0.5-1-1v-6.5c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1v6.5C897,143.6,896.5,144.1,895.9,144.1z "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M884.1,143.7c-0.6,0-1-0.5-1-1v-6.2c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1v6.2 C885.1,143.3,884.7,143.7,884.1,143.7z"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M907.7,144.1c-0.6,0-1-0.5-1-1v-6.5c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1v6.5 C908.8,143.6,908.3,144.1,907.7,144.1z"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M919.5,144.1c-0.6,0-1-0.5-1-1v-6.5c0-0.6,0.5-1,1-1s1,0.5,1,1v6.5C920.6,143.6,920.1,144.1,919.5,144.1z"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M931.3,144.1c-0.6,0-1-0.5-1-1v-6.5c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1v6.5 C932.4,143.6,931.9,144.1,931.3,144.1z"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M943.1,144.1c-0.6,0-1-0.5-1-1v-6.5c0-0.6,0.5-1,1-1s1,0.5,1,1v6.5C944.2,143.6,943.7,144.1,943.1,144.1z"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M954.9,143.7c-0.6,0-1-0.5-1-1v-6.2c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1v6.2C956,143.3,955.5,143.7,954.9,143.7z "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M954.9,140.8h-75.3c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h75.3c0.6,0,1,0.5,1,1 C956,140.4,955.5,140.8,954.9,140.8z"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M890.7,364.6h-34.1v0.5h34.1v-0.3h-34.1h34.1V364.6z"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M890.7,370.3h-34.1v0.5h34.1v-0.3h-34.1h34.1V370.3z"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M890.7,375.9h-34.1v0.5h34.1v-0.3h-34.1h34.1V375.9z"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M890.7,381.5h-34.1v0.5h34.1v-0.3h-34.1h34.1V381.5z"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M732.2,132.9c0-1.7-1.4-3.1-3.1-3.1c-1.7,0-3.1,1.4-3.1,3.1"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M686.6,230.9h-3.8l-3.7-82.7h11.2L686.6,230.9z M683.8,229.8h1.8l3.6-80.6h-9L683.8,229.8z"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M684.7,248.9c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c0.6,0,1,0.5,1,1c0,0.6-0.5,1-1,1 c-0.9,0-1.7,0.7-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.7,1.7-1.7c0-0.6,0.5-1,1-1s1,0.5,1,1 C688.4,247.2,686.7,248.9,684.7,248.9L684.7,248.9z"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M684.7,243.4c-0.6,0-1-0.5-1-1v-4c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1v4C685.7,243,685.2,243.4,684.7,243.4z"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M682.9,240h3.6c0.5,0,0.9-0.3,1-0.7l1.8-6.6h-9.2l1.8,6.6C682,239.7,682.4,240,682.9,240L682.9,240z"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M680.1,232.7c0-2.5,2.1-4.6,4.6-4.6s4.6,2,4.6,4.6"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M678.2,151.2h13c1.2,0,2.1-0.9,2.1-2.1v-2.8h-17.2v2.8C676.1,150.2,677,151.2,678.2,151.2L678.2,151.2z"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M885,165.9h-4.7c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h4.7c0.6,0,1,0.5,1,1C886.1,165.4,885.6,165.9,885,165.9z"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M884.2,137.6h-4c-0.6,0-1-0.5-1-1s0.5-1,1-1h4c0.6,0,1,0.5,1,1S884.8,137.6,884.2,137.6z"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M868.3,134h-25.1c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h25.1c0.6,0,1,0.5,1,1C869.4,133.5,868.9,134,868.3,134z"
  })))), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1344.5,388h-82.9V216.1l82.9-18.3V388z"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1265.3,388h-7.3V214.7h7.3V388z"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1286,388h-7.3V207.8h7.3V388z"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1306.7,388h-7.3V202.6h7.3V388z"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1327.4,388h-7.3V198.4h7.3V388z"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1348.2,388h-7.3V194h7.3V388z"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,231h4.8V227h-4.8V231z"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,239.3h4.8V231h-4.8V239.3z"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,256.6h4.8v-6.1h-4.8V256.6z"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,262.7h4.8v-6.1h-4.8V262.7z"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,282.2h4.8v-8.3h-4.8V282.2z"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,286.2h4.8v-3.9h-4.8V286.2z"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,307.9h4.8v-10.5h-4.8V307.9z"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,309.6h4.8v-1.7h-4.8V309.6z"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,331.7h4.8v-9.1h-4.8V331.7z"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,322.6h4.8v-3.1h-4.8V322.6z"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,355.2h4.8v-6.9h-4.8V355.2z"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.6,348.3h4.8v-5.3h-4.8V348.3z"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,231h4.8V227h-4.8V231z"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,239.3h4.8V231h-4.8V239.3z"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,256.6h4.8v-6.1h-4.8V256.6z"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,262.7h4.8v-6.1h-4.8V262.7z"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,282.2h4.8v-8.3h-4.8V282.2z"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,286.2h4.8v-3.9h-4.8V286.2z"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,307.9h4.8v-10.5h-4.8V307.9z"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,309.6h4.8v-1.7h-4.8V309.6z"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,331.7h4.8v-9.1h-4.8V331.7z"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,322.6h4.8v-3.1h-4.8V322.6z"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,355.2h4.8v-6.9h-4.8V355.2z"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1292.3,348.3h4.8v-5.3h-4.8V348.3z"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,231h4.8V227h-4.8V231z"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,239.3h4.8V231h-4.8V239.3z"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,256.6h4.8v-6.1h-4.8V256.6z"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,262.7h4.8v-6.1h-4.8V262.7z"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,282.2h4.8v-8.3h-4.8V282.2z"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,286.2h4.8v-3.9h-4.8V286.2z"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,307.9h4.8v-10.5h-4.8V307.9z"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,309.6h4.8v-1.7h-4.8V309.6z"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,331.7h4.8v-9.1h-4.8V331.7z"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,322.6h4.8v-3.1h-4.8V322.6z"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,355.2h4.8v-6.9h-4.8V355.2z"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1313,348.3h4.8v-5.3h-4.8V348.3z"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,231h4.8V227h-4.8V231z"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,239.3h4.8V231h-4.8V239.3z"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,256.6h4.8v-6.1h-4.8V256.6z"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,262.7h4.8v-6.1h-4.8V262.7z"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,282.2h4.8v-8.3h-4.8V282.2z"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,286.2h4.8v-3.9h-4.8V286.2z"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,307.9h4.8v-10.5h-4.8V307.9z"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,309.6h4.8v-1.7h-4.8V309.6z"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,331.7h4.8v-9.1h-4.8V331.7z"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,322.6h4.8v-3.1h-4.8V322.6z"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,355.2h4.8v-6.9h-4.8V355.2z"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1333.8,348.3h4.8v-5.3h-4.8V348.3z"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1278.8,245.7h-9.7V231h2.4v8.3h4.8V231h2.4V245.7z"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1299.6,245.7h-9.7V231h2.4v8.3h4.8V231h2.4V245.7z"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1310.6,245.7h9.7V231h-9.7V245.7z"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1341,245.7h-9.7V231h2.4v8.3h4.8V231h2.4V245.7z"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1269.2,271.3h9.7v-14.7h-9.7V271.3z"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1289.9,271.3h9.7v-14.7h-9.7V271.3z"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1320.3,271.3h-9.7v-14.7h2.4v6.1h4.8v-6.1h2.4V271.3z"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1341,271.3h-9.7v-14.7h2.4v6.1h4.8v-6.1h2.4V271.3z"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1278.8,297h-9.7v-14.7h2.4v3.9h4.8v-3.9h2.4V297z"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1299.6,297h-9.7v-14.7h2.4v3.9h4.8v-3.9h2.4V297z"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1320.3,297h-9.7v-14.7h2.4v3.9h4.8v-3.9h2.4V297z"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1331.3,297h9.7v-14.7h-9.7V297z"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1278.8,322.6h-2.4v-3.1h-4.8v3.1h-2.4v-14.7h2.4v1.7h4.8v-1.7h2.4V322.6z"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1289.9,322.6h9.7v-14.7h-9.7V322.6z"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1320.3,322.6h-2.4v-3.1h-4.8v3.1h-2.4v-14.7h2.4v1.7h4.8v-1.7h2.4V322.6z"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1341,322.6h-2.4v-3.1h-4.8v3.1h-2.4v-14.7h2.4v1.7h4.8v-1.7h2.4V322.6z"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1278.8,348.3h-2.4v-5.3h-4.8v5.3h-2.4v-14.7h9.7V348.3z"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1299.6,348.3h-2.4v-5.3h-4.8v5.3h-2.4v-14.7h9.7V348.3z"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1310.6,348.3h9.7v-14.7h-9.7V348.3z"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1341,348.3h-2.4v-5.3h-4.8v5.3h-2.4v-14.7h9.7V348.3z"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1278.8,373.9h-9.7v-14.7h9.7V373.9z"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1299.6,373.9h-9.7v-14.7h9.7V373.9z"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1310.6,373.9h9.7v-14.7h-9.7V373.9z"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1331.3,373.9h9.7v-14.7h-9.7V373.9z"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1269.2,379.8h9.7v-13.3h-9.7V379.8z"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1299.6,379.8h-9.7v-13.3h9.7V379.8z"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1310.6,379.8h9.7v-13.3h-9.7V379.8z"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1341,379.8h-9.7v-13.3h9.7V379.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustracion);
export default __webpack_public_path__ + "static/media/ilustracion.fbe509e9d7e42c63375a10b67cdc9485.svg";
export { ForwardRef as ReactComponent };